import React, {Component} from 'react';
import {connect} from 'react-redux';

class Translate extends Component {

  constructor (props) {
    super(props);
  }

  render () {
    const {translations, slug, slugVisible, html} = this.props;
    let text = '', debug = false;

    if (translations[slug] && !slugVisible) {
      if (!html) {
        text = translations[slug];
      } else {
        text = <div className="translate__html" dangerouslySetInnerHTML={{__html: translations[slug]}}></div>;
      }
    } else {
      text = <span style={{color: 'red', textTransform: 'lowercase', whiteSpace: 'nowrap'}}>{slug}</span>;
    }

    return (
      <span>{text}</span>
    );
  }
}


function mapStateToProps (state) {
  return {
    translations: state.user.translations,
    slugVisible: state.user.slugVisible
  }
}


export default connect(mapStateToProps)(Translate)




// WEBPACK FOOTER //
// ./src/common/components/layout/Translate.js